import 'jquery-validation';

/* ==============================
   Checkout Form – Validálás + Stripe
   jQuery Validate plugin alapján (mint auth.js)
   ============================== */

$(function () {

	/* ---------- szállítási díj újraszámolás (oldal újratöltés nélkül) ---------- */

	var shippingState = window.checkoutShipping || null;
	var couponState = window.checkoutCoupon || null;
	var couponLang = window.checkoutCouponLang || {};

	function couponDiscount() {
		return couponState && couponState.valid ? Number(couponState.discount) || 0 : 0;
	}

	function formatAmount(amount) {
		var symbol = shippingState && shippingState.currency_symbol ? shippingState.currency_symbol : '';
		var rounded = Math.round(Number(amount) || 0);
		return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ' + symbol;
	}

	function selectedShippingPrice() {
		if (!shippingState || !shippingState.methods) {
			return 0;
		}
		var method = $('input[name="shipping_method"]:checked').val();
		for (var i = 0; i < shippingState.methods.length; i++) {
			if (shippingState.methods[i].key === method) {
				return shippingState.methods[i].price;
			}
		}
		return shippingState.methods.length ? shippingState.methods[0].price : 0;
	}

	function selectedPaymentFee() {
		if (!shippingState || !shippingState.payment_methods) {
			return { amount: 0, label: '' };
		}
		var method = $('input[name="payment_method"]:checked').val();
		for (var i = 0; i < shippingState.payment_methods.length; i++) {
			if (shippingState.payment_methods[i].key === method) {
				return { amount: shippingState.payment_methods[i].fee, label: shippingState.payment_methods[i].fee_label };
			}
		}
		return { amount: 0, label: '' };
	}

	function renderTotals() {
		if (!shippingState) {
			return;
		}
		var shippingFee = selectedShippingPrice();
		var paymentFee = selectedPaymentFee();
		$('#cartSubtotal').text(formatAmount(shippingState.subtotal));
		$('#cartShippingFee').text(formatAmount(shippingFee));
		$('#cartAdminFee').text(formatAmount(shippingState.admin_fee));
		$('#cartPaymentFee').text(formatAmount(paymentFee.amount));
		$('#cartPaymentFeeLabel').text(paymentFee.label);
		$('#cartPaymentFeeRow').toggle(Number(paymentFee.amount) > 0);
		$('#cartGrandTotal').text(formatAmount(Math.max(0, shippingState.subtotal - couponDiscount()) + shippingFee + shippingState.admin_fee + Number(paymentFee.amount || 0)));
	}

	function renderCoupon() {
		var valid = !!(couponState && couponState.valid);
		$('#co_coupon_code').toggleClass('is-valid', valid).toggleClass('is-invalid', !!couponState && !valid);
		$('#couponMessage').text(couponState ? couponState.message || '' : '')
			.toggleClass('d-none', !couponState)
			.toggleClass('text-success', valid)
			.toggleClass('text-danger', !!couponState && !valid);
		$('#couponRemoveBtn').toggleClass('d-none', !valid);
		$('#cartCouponRow').toggleClass('d-none', !valid);
		$('#cartCouponCode').text(valid ? '(' + couponState.code + ')' : '');
		$('#cartCouponDiscount').text('-' + formatAmount(couponDiscount()));
		renderTotals();
	}

	function applyCoupon() {
		var $button = $('#couponApplyBtn');
		var code = $.trim($('#co_coupon_code').val() || '').toUpperCase();
		$('#co_coupon_code').val(code);
		$button.prop('disabled', true);
		$.ajax({
			url: '/checkout/coupon',
			method: 'POST',
			data: { _token: window.csrfToken, code: code },
			success: function (response) {
				couponState = response;
				renderCoupon();
			},
			error: function (xhr) {
				couponState = {
					valid: false, code: code, discount: 0,
					message: (xhr.responseJSON && xhr.responseJSON.message) || (couponLang.errors && couponLang.errors.request_failed)
				};
				renderCoupon();
			},
			complete: function () {
				$button.prop('disabled', false);
			}
		});
	}

	$(document).on('click', '#couponApplyBtn', applyCoupon);
	$(document).on('keydown', '#co_coupon_code', function (event) {
		if (event.key === 'Enter') {
			event.preventDefault();
			applyCoupon();
		}
	});
	$(document).on('click', '#couponRemoveBtn', function () {
		var $button = $(this).prop('disabled', true);
		$.ajax({
			url: '/checkout/coupon/remove',
			method: 'POST',
			data: { _token: window.csrfToken },
			success: function () {
				couponState = null;
				$('#co_coupon_code').val('');
				renderCoupon();
			},
			error: function (xhr) {
				$('#couponMessage').text((xhr.responseJSON && xhr.responseJSON.message) || (couponLang.errors && couponLang.errors.request_failed))
					.removeClass('d-none text-success').addClass('text-danger');
			},
			complete: function () {
				$button.prop('disabled', false);
			}
		});
	});

	function renderShippingMethods() {
		if (!shippingState || !shippingState.methods) {
			return;
		}
		var $wrap = $('#shippingMethodsBlock');
		if (!$wrap.length) {
			return;
		}
		var current = $('input[name="shipping_method"]:checked').val();
		var available = shippingState.methods.map(function (m) { return m.key; });
		if (available.indexOf(current) === -1) {
			current = shippingState.selected_method || available[0];
		}

		var html = '';
		shippingState.methods.forEach(function (method) {
			var isActive = method.key === current;
			html += '<label id="shippingOpt_' + method.key + '" class="checkout-shipping-option' + (isActive ? ' active' : '') + '">'
				+ '<div class="d-flex align-items-center gap-2">'
				+ '<input type="radio" name="shipping_method" value="' + method.key + '"' + (isActive ? ' checked' : '') + '>'
				+ '<span></span>'
				+ '</div>'
				+ '<span class="checkout-shipping-price">' + formatAmount(method.price) + '</span>'
				+ '</label>';
		});
		$wrap.html(html);
		// A label szövegét textként írjuk be, hogy ne legyen HTML injektálás a szerver válaszából.
		shippingState.methods.forEach(function (method) {
			$('#shippingOpt_' + method.key).find('span').first().text(method.label);
		});

		$('#glsPickupBlock').toggle(current === 'gls_pickup');
		$('#foxpostPickupBlock').toggle(current === 'foxpost_pickup');
		updateGlsSubmitState();
		updateFoxpostSubmitState();
	}

	function refreshShipping() {
		$.ajax({
			url: '/checkout/shipping-options',
			method: 'POST',
			data: {
				_token: window.csrfToken,
				country: $('#co_country').val(),
				shipping_method: $('input[name="shipping_method"]:checked').val(),
				payment_method: $('input[name="payment_method"]:checked').val()
			},
			success: function (resp) {
				if (!resp || !resp.success) {
					return;
				}
				shippingState = resp;
				renderShippingMethods();
				renderTotals();
			}
		});
	}

	$(document).on('change', '#co_country', refreshShipping);

	/* ---------- fizetési mód váltás ---------- */

	$(document).on('change', 'input[name="payment_method"]', function () {
		$('#paymentMethodsBlock .checkout-shipping-option').removeClass('active');
		$(this).closest('.checkout-shipping-option').addClass('active');
		refreshShipping();
		renderTotals();
	});

	/* ---------- szállítási mód váltás ---------- */

	$(document).on('change', 'input[name="shipping_method"]', function () {
		var val = $(this).val();
		$('#shippingMethodsBlock .checkout-shipping-option').removeClass('active');
		$(this).closest('.checkout-shipping-option').addClass('active');

		if (val === 'gls_pickup') {
			$('#glsPickupBlock').show();
			updateGlsSubmitState();
		} else {
			$('#glsPickupBlock').hide();
			$('#gls_parcelshop_id').val('');
			$('#gls_parcelshop_name').val('');
			$('#gls_parcelshop_address').val('');
			$('#glsPickupName').text(window.Lang.co_no_parcel);
			$('#glsPickupAddress').text('');
			$('#glsPickupSelectBtn').removeClass('btn-danger').addClass('btn-outline-secondary');
			updateGlsSubmitState();
		}

		if (val === 'foxpost_pickup') {
			$('#foxpostPickupBlock').show();
			updateFoxpostSubmitState();
		} else {
			$('#foxpostPickupBlock, #foxpostPickerWrap').hide();
			$('#foxpost_parcelshop_id, #foxpost_parcelshop_place_id, #foxpost_parcelshop_name, #foxpost_parcelshop_address').val('');
			$('#foxpostPickupName').text(window.Lang.co_no_parcel);
			$('#foxpostPickupAddress').text('');
			updateFoxpostSubmitState();
		}
		renderTotals();
		// GLS mező újravalidálás ha már volt submit kísérlet
		var validator = $('#checkoutForm').data('validator');
		if (validator) {
			['#gls_parcelshop_id', '#foxpost_parcelshop_id', '#co_zip', '#co_city', '#co_address'].forEach(function (sel) {
				if ($(sel).length) validator.element(sel);
			});
		}
	});

	/* ---------- submit gomb letiltás GLS csomagpont nélkül ---------- */

	function updateGlsSubmitState() {
		var method = $('input[name="shipping_method"]:checked').val();
		var hasShop = $('#gls_parcelshop_id').val().trim() !== '';
		if (method === 'gls_pickup' && !hasShop) {
			$('#checkoutSubmitBtn').addClass('disabled').prop('disabled', true);
			$('#glsPickupAlert').show();
		} else {
			$('#checkoutSubmitBtn').removeClass('disabled').prop('disabled', false);
			$('#glsPickupAlert').hide();
		}
	}

	function updateFoxpostSubmitState() {
		var method = $('input[name="shipping_method"]:checked').val();
		var hasShop = $('#foxpost_parcelshop_id').val().trim() !== '';
		if (method === 'foxpost_pickup' && !hasShop) {
			$('#checkoutSubmitBtn').addClass('disabled').prop('disabled', true);
			$('#foxpostPickupAlert').show();
		} else {
			$('#checkoutSubmitBtn').removeClass('disabled').prop('disabled', false);
			$('#foxpostPickupAlert').hide();
		}
	}

	// gls.js csomagpont kiválasztás után is frissít
	$(document).on('glsParcelShopSelected', function () {
		if ($('#checkoutForm').length) {
			updateGlsSubmitState();
			var validator = $('#checkoutForm').data('validator');
			if (validator) {
				validator.element('#gls_parcelshop_id');
			}
		}


	});

	$(document).on('foxpostParcelShopSelected', function () {
		updateFoxpostSubmitState();
		var validator = $('#checkoutForm').data('validator');
		if (validator) {
			validator.element('#foxpost_parcelshop_id');
		}
	});

	if ($('#checkoutForm').length) {
		var initialShippingMethod = $('input[name="shipping_method"]:checked').val();
		$('#glsPickupBlock').toggle(initialShippingMethod === 'gls_pickup');
		$('#foxpostPickupBlock').toggle(initialShippingMethod === 'foxpost_pickup');
		updateGlsSubmitState();
		updateFoxpostSubmitState();
	}


	/* ---------- Számlázási adatok ---------- */

	$('#copyShippingToBilling').on('click', function () {
		var invoiceType = $('input[name="invoice_type"]:checked').val();
		var name = invoiceType === 'company' ? $('#co_company').val().trim() : '';
		$('#inv_name').val(name || [$('#co_first_name').val().trim(), $('#co_last_name').val().trim()].filter(Boolean).join(' '));
		$('#inv_country').val($('#co_country').val());
		$('#inv_zip').val($('#co_zip').val().trim());
		$('#inv_city').val($('#co_city').val().trim());
		$('#inv_street').val([
			$('#co_address').val().trim(),
			$('#co_door').val().trim(),
			$('#co_address2').val().trim()
		].filter(Boolean).join(' '));
		$('#billingFields').find('input:visible, select:visible').valid();
	});

	function updateInvoiceType() {
		var isCompany = $('input[name="invoice_type"]:checked').val() === 'company';
		$('#vatNumberRow').toggle(isCompany);
		$('#inv_vat').prop('required', isCompany);
		if (!isCompany) {
			$('#inv_vat').val('');
			if ($('#checkoutForm').data('validator')) {
				$('#inv_vat').valid();
			}
		}
	}

	$('input[name="invoice_type"]').on('change', updateInvoiceType);
	updateInvoiceType();

	/* ---------- Adószám ellenőrzés (NAV lekérdezés a Billingo API-n keresztül) ---------- */

	var taxNumberPattern = /^\d{8}-\d{1}-\d{2}$/;

	$('#inv_vat').on('blur input', function () {
		var taxNumber = $(this).val().trim();
		if (!taxNumberPattern.test(taxNumber)) {
			return;
		}

		$('#taxNumberRow').show();
		var countryCode = ($('#inv_country').val() || 'HU').trim();

		$.ajax({
			url: '/validateTaxNumber/' + encodeURIComponent(taxNumber) + '/' + encodeURIComponent(countryCode),
			method: 'GET',
			success: function (resp) {
				$('#taxNumberRow').hide();
				if (!resp || !resp.success || !resp.invoice_data) {
					return;
				}
				var data = resp.invoice_data;
				if (data.inv_name) {
					$('#inv_name').val(data.inv_name);
				}
				if (data.inv_zip) {
					$('#inv_zip').val(data.inv_zip);
				}
				if (data.inv_city) {
					$('#inv_city').val(data.inv_city);
				}
				if (data.inv_street) {
					$('#inv_street').val(data.inv_street);
				}
			}
		});
	});


	/* ---------- custom validator: GLS csomagpont ---------- */

	function isGlsPickup() {
		return $('input[name="shipping_method"]:checked').val() === 'gls_pickup';
	}

	function isFoxpostPickup() {
		return $('input[name="shipping_method"]:checked').val() === 'foxpost_pickup';
	}

	// Csomagpontos szállításnál nincs házhozszállítási cím, ezért ezek a mezők nem kötelezőek.
	function addressRequired() {
		return !isGlsPickup() && !isFoxpostPickup();
	}

	$.validator.addMethod('glsPickupRequired', function (value) {
		if (isGlsPickup()) {
			return value.trim() !== '';
		}
		return true;
	}, window.Lang.co_val_gls);

	$.validator.addMethod('foxpostPickupRequired', function (value) {
		return !isFoxpostPickup() || value.trim() !== '';
	}, window.Lang.co_val_gls);

	/* ---------- jQuery Validate ---------- */

	if ($('#checkoutForm').length) {
		$('#checkoutForm').validate({
			ignore: ':hidden:not(#gls_parcelshop_id):not(#foxpost_parcelshop_id), #co_coupon_code',
			rules: {
				email: {
					required: true,
					email: true
				},
				first_name: {
					required: true
				},
				last_name: {
					required: true
				},
				zip: {
					required: addressRequired
				},
				city: {
					required: addressRequired
				},
				address: {
					required: addressRequired
				},
				door: {
					required: addressRequired
				},
				phone: {
					required: true
				},
				gls_parcelshop_id: {
					glsPickupRequired: true
				},
				foxpost_parcelshop_id: {
					foxpostPickupRequired: true
				},
				terms: {
					required: true
				},
				data_privacy: {
					required: true
				},
				invoice_type: {
					required: true
				},
				invoice_name: {
					required: true
				},
				invoice_country: {
					required: true
				},
				invoice_zip: {
					required: true
				},
				invoice_city: {
					required: true
				},
				invoice_street: {
					required: true
				},
				invoice_vat: {
					required: function () {
						return $('input[name="invoice_type"]:checked').val() === 'company';
					}
				}
			},
			messages: {
				email: {
					required: window.Lang.co_val_email_required,
					email: window.Lang.co_val_email_invalid
				},
				first_name: {
					required: window.Lang.co_val_first_name
				},
				last_name: {
					required: window.Lang.co_val_last_name
				},
				zip: {
					required: window.Lang.co_val_zip
				},
				city: {
					required: window.Lang.co_val_city
				},
				address: {
					required: window.Lang.co_val_address
				},
				door: {
					required: window.Lang.co_val_door
				},
				phone: {
					required: window.Lang.co_val_phone
				},
				gls_parcelshop_id: {
					glsPickupRequired: window.Lang.co_val_gls
				},
				foxpost_parcelshop_id: {
					foxpostPickupRequired: window.Lang.co_val_foxpost
				},
				terms: {
					required: window.Lang.co_val_terms
				},
				data_privacy: {
					required: window.Lang.co_val_data_privacy
				},
				invoice_type: {
					required: window.Lang.co_val_invoice_type
				},
				invoice_name: {
					required: window.Lang.co_val_invoice_name
				},
				invoice_country: {
					required: window.Lang.co_val_invoice_country
				},
				invoice_zip: {
					required: window.Lang.co_val_zip
				},
				invoice_city: {
					required: window.Lang.co_val_city
				},
				invoice_street: {
					required: window.Lang.co_val_address
				},
				invoice_vat: {
					required: window.Lang.co_val_invoice_vat
				}
			},
			errorElement: 'span',
			errorClass: 'text-danger small d-block',
			validClass: '',
			errorPlacement: function (error, element) {
				if (element.attr('type') === 'checkbox') {
					error.insertAfter(element.closest('label'));
				} else if (element.attr('name') === 'gls_parcelshop_id') {
					error.appendTo('#glsPickupBlock');
				} else if (element.attr('name') === 'foxpost_parcelshop_id') {
					error.appendTo('#foxpostPickupBlock');
				} else {
					error.insertAfter(element);
				}
			},
			highlight: function (element) {
				$(element).addClass('is-invalid').removeClass('is-valid');
			},
			unhighlight: function (element) {
				$(element).removeClass('is-invalid').addClass('is-valid');
			},
			invalidHandler: function () {
				var $first = $('#checkoutForm .is-invalid').first();
				if ($first.length) {
					$('html,body').animate({ scrollTop: $first.offset().top - 120 }, 300);
				}
			},
			submitHandler: function () {
				$('#checkoutBtnText').hide();
				$('#checkoutBtnSpinner').show();
				$('#checkoutSubmitBtn').prop('disabled', true);

				var payload = {
					_token: window.csrfToken,
					email: $('#co_email').val().trim(),
					first_name: $('#co_first_name').val().trim(),
					last_name: $('#co_last_name').val().trim(),
					company: $('#co_company').val().trim(),
					zip: $('#co_zip').val().trim(),
					city: $('#co_city').val().trim(),
					address: $('#co_address').val().trim(),
					door: $('#co_door').val().trim(),
					address2: $('#co_address2').val().trim(),
					phone: $('#co_phone').val().trim(),
					country: $('#co_country').val().trim(),
					shipping_method: $('input[name="shipping_method"]:checked').val(),
					gls_parcelshop_id: $('#gls_parcelshop_id').val(),
					gls_parcelshop_name: $('#gls_parcelshop_name').val(),
					gls_parcelshop_address: $('#gls_parcelshop_address').val(),
					foxpost_parcelshop_id: $('#foxpost_parcelshop_id').val(),
					foxpost_parcelshop_place_id: $('#foxpost_parcelshop_place_id').val(),
					foxpost_parcelshop_name: $('#foxpost_parcelshop_name').val(),
					foxpost_parcelshop_address: $('#foxpost_parcelshop_address').val(),
					newsletter: $('input[name="newsletter"]').is(':checked') ? 1 : 0,
					save_address: $('input[name="save_address"]').is(':checked') ? 1 : 0,
					save_billing: $('input[name="save_billing"]').is(':checked') ? 1 : 0,
					// Számlázási adatok
					invoice_type: $('input[name="invoice_type"]:checked').val(),
					invoice_name: $('#inv_name').val().trim(),
					invoice_vat: $('#inv_vat').val().trim(),
					invoice_country: $('#inv_country').val().trim(),
					invoice_zip: $('#inv_zip').val().trim(),
					invoice_city: $('#inv_city').val().trim(),
					invoice_street: $('#inv_street').val().trim(),
					payment_method: $('input[name="payment_method"]:checked').val() || 'bankcard',
				};

				// 1. lépés: rendelés mentése az adatbázisban
				$.ajax({
					url: '/order/store',
					method: 'POST',
					data: payload,
					success: function (orderResp) {
						if (!orderResp.success) {
							resetSubmitBtn();
							GlobalSwal.fire({ icon: 'error', title: window.Lang.error_title_short, text: orderResp.message || window.Lang.co_order_save_error });
							return;
						}

						// Utánvét / átutalás esetén nincs online fizetés, a rendelés már véglegesítve lett.
						if (orderResp.payment_method !== 'bankcard') {
							window.location.href = '/order/thank-you/' + orderResp.order_number;
							return;
						}

						// 2. lépés: Barion fizetés indítása az order_id-val
						$.ajax({
							url: '/barion/checkout',
							method: 'POST',
							data: { _token: window.csrfToken, order_id: orderResp.order_id },
							success: function (resp) {
								if (resp.url) {
									window.location.href = resp.url;
								} else {
									resetSubmitBtn();
									GlobalSwal.fire({ icon: 'error', title: window.Lang.error_title_short, text: resp.message || window.Lang.co_unknown_error });
								}
							},
							error: function (xhr) {
								resetSubmitBtn();
								if (xhr.responseJSON && xhr.responseJSON.coupon_invalid) {
									couponState = xhr.responseJSON.coupon;
									renderCoupon();
									$('html,body').animate({ scrollTop: $('#checkoutCouponBox').offset().top - 120 }, 300);
									return;
								}
								var msg = xhr.responseJSON && xhr.responseJSON.message
									? xhr.responseJSON.message
									: window.Lang.co_payment_open_error;
								GlobalSwal.fire({ icon: 'error', title: window.Lang.error_title_short, text: msg });
							}
						});
					},
					error: function (xhr) {
						resetSubmitBtn();
						var msg = xhr.responseJSON && xhr.responseJSON.message
							? xhr.responseJSON.message
							: window.Lang.co_order_process_error;
						GlobalSwal.fire({ icon: 'error', title: window.Lang.error_title_short, text: msg });
					}
				});
			}
		});
	}



	function resetSubmitBtn() {
		$('#checkoutBtnText').show();
		$('#checkoutBtnSpinner').hide();
		$('#checkoutSubmitBtn').prop('disabled', false);
	}

});
